import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2930add1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-overlay" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "overlay" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "modal-click-overlay",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeOnClick && _ctx.back()))
        }),
        _createElementVNode("div", {
          class: _normalizeClass(["modal-contents", _ctx.contentClass]),
          style: _normalizeStyle({
                padding: '8px ' + _ctx.sizes.padding,
                'max-width': _ctx.sizes.max
            })
        }, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ], 6)
      ], 512), [
        [_vShow, _ctx.isOpen]
      ])
    ]),
    _: 3
  }))
}